//src/services/adminProducts.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminProducts = () => {
  return adminApiRequest("/admin/products");
};

export const deleteAdminProduct = (id) => {
  return adminApiRequest(`/admin/products/${id}`, {
    method: "DELETE",
  });
};

export const getAdminProductById = (id) => {
  return adminApiRequest(`/admin/products/${id}`);
};

export const updateAdminProduct = (id, data) => {
  return adminApiRequest(`/admin/products/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const getAdminCategories = () => {
  return adminApiRequest("/admin/meta/categories");
};

export const getAdminTags = () => {
  return adminApiRequest("/admin/meta/tags");
};

/* ✅ ADD THESE (NEW) */
export const createAdminProduct = (data) => {
  return adminApiRequest("/admin/products", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const createAdminTag = (data) => {
  return adminApiRequest("/admin/meta/tags", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const getAdminCategoriesWithProducts = () => {
  return adminApiRequest("/admin/categories");
};

export const createAdminCategory = (data) => {
  return adminApiRequest("/admin/categories", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const deleteAdminCategory = (id) => {
  return adminApiRequest(`/admin/categories/${id}`, {
    method: "DELETE",
  });
};

export const deleteAdminProductImage = (imageId) => {
  return adminApiRequest(`/admin/product-images/${imageId}`, {
    method: "DELETE",
  });
};

export const makeProductsOnSale = (productIds, percent) => {
  return adminApiRequest("/admin/products/make-sale", {
    method: "POST",
    body: JSON.stringify({
      productIds,
      sale_percent: percent,
    }),
  });
};

export const removeProductsFromSale = (productIds) => {
  return adminApiRequest("/admin/products/remove-sale", {
    method: "POST",
    body: JSON.stringify({ productIds }),
  });
};

export const toggleAdminProductVisibility = (id) => {
  return adminApiRequest(`/admin/products/${id}/toggle-visibility`, {
    method: "POST",
  });
};

export const checkAdminSlug = (slug) => {
  return adminApiRequest(`/admin/products/check-slug?slug=${slug}`);
};

export const createAdminDiscount = (data) => {
  return adminApiRequest("/admin/discounts", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateAdminCategory = (id, data) => {
  return adminApiRequest(`/admin/categories/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const getAdminCategoryProducts = (categoryId, page = 1, limit = 20) => {
  return adminApiRequest(`/admin/categories/${categoryId}/products?page=${page}&limit=${limit}`);
};

export const removeAdminProductFromCategory = (categoryId, productId) => {
  return adminApiRequest(`/admin/categories/${categoryId}/products/${productId}`, {
    method: "DELETE",
  });
};

export const addProductsToCategory = (categoryId, productIds) => {
  return adminApiRequest(`/admin/categories/${categoryId}/products`, {
    method: "POST",
    body: JSON.stringify({ productIds }),
  });
};

export const getAdminPricesSalesVisibility = () => {
  return adminApiRequest("/admin/price-visibility");
};

export const toggleAdminPricesSalesVisibility = () => {
  return adminApiRequest("/admin/price-visibility/toggle", {
    method: "POST",
  });
};
